
import React from "react";
import { Crown, Lock, Star, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

interface HiddenPredictionCardProps {
  index: number;
}

const HiddenPredictionCard: React.FC<HiddenPredictionCardProps> = ({ index }) => {
  return (
    <div className="relative bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-400 dark:from-yellow-600/40 dark:via-yellow-500/50 dark:to-amber-600/60 border-2 border-yellow-400 dark:border-yellow-500 rounded-xl p-4 flex flex-col items-center justify-center min-h-[120px] w-full max-w-[120px] group hover:border-yellow-500 hover:shadow-2xl hover:shadow-yellow-500/50 transition-all duration-500 hover:scale-105 transform">
      {/* Gradiente de fundo animado */}
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/30 via-amber-400/40 to-yellow-600/30 rounded-xl opacity-80 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Brilho dourado */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-yellow-300/20 to-yellow-500/20 rounded-xl opacity-50 group-hover:opacity-80 transition-opacity duration-500"></div>
      
      {/* Estrelas decorativas */}
      <div className="absolute top-2 left-2">
        <Star className="w-3 h-3 text-yellow-600 animate-pulse" fill="currentColor" />
      </div>
      <div className="absolute top-2 right-2">
        <Sparkles className="w-3 h-3 text-yellow-600 animate-pulse" />
      </div>
      <div className="absolute bottom-2 left-2">
        <Star className="w-2 h-2 text-yellow-500 animate-pulse" fill="currentColor" />
      </div>
      <div className="absolute bottom-2 right-2">
        <Sparkles className="w-2 h-2 text-yellow-500 animate-pulse" />
      </div>
      
      <div className="relative z-10 flex flex-col items-center justify-center text-center space-y-2">
        <div className="flex items-center space-x-1 mb-1">
          <Crown className="w-6 h-6 text-yellow-700 dark:text-yellow-300 animate-bounce" fill="currentColor" />
          <Lock className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
        </div>
        
        <div className="text-sm font-bold text-yellow-800 dark:text-yellow-200 drop-shadow-sm">
          Palpite #{index}
        </div>
        
        <div className="px-3 py-1 bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-600 text-white text-xs font-bold rounded-full shadow-lg border border-yellow-400">
          ✨ VIP GOLD ✨
        </div>
        
        <Link 
          to="/planos" 
          className="text-xs text-yellow-800 dark:text-yellow-200 hover:text-yellow-900 dark:hover:text-yellow-100 hover:underline font-bold transition-colors mt-2 bg-yellow-300/50 dark:bg-yellow-600/30 px-2 py-1 rounded-md shadow-sm hover:shadow-md"
        >
          🚀 UPGRADE AGORA
        </Link>
      </div>
      
      {/* Coroa grande no fundo */}
      <div className="absolute bottom-1 right-1 opacity-20">
        <Crown className="w-6 h-6 text-yellow-600" fill="currentColor" />
      </div>
      
      {/* Pontos brilhantes animados */}
      <div className="absolute top-3 left-3">
        <div className="w-1 h-1 bg-yellow-400 rounded-full animate-ping"></div>
      </div>
      <div className="absolute top-4 right-4">
        <div className="w-1 h-1 bg-yellow-500 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
      </div>
      <div className="absolute bottom-3 right-3">
        <div className="w-1 h-1 bg-yellow-400 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
      </div>
      
      {/* Efeito de borda brilhante */}
      <div className="absolute inset-0 rounded-xl border border-yellow-300 opacity-50 group-hover:opacity-100 transition-opacity duration-500"></div>
    </div>
  );
};

export default HiddenPredictionCard;
